export default "__VITE_ASSET__2b9fd040__"